export enum AssetCodeWidth {
  S = 8,
}
